"use client";

import Cookies from "js-cookie";
import ForgotPasswordGraphic from "@/components/ForgotPasswordGraphic";
import Link from "next/link";
import { useState } from "react";

export default function ForgotPassword() {
  const [email, setEmail] = useState(Cookies.get("userEmail") || "");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    // Call the API endpoint to initiate the password reset process
    const response = await fetch("/api/auth/forgot-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    setLoading(false);

    if (data.error) {
      setError(data.message);
    } else {
      setMessage(
        "If an account with that email exists, we have sent a password reset link."
      );
    }
  };

  return (
    <div className="flex flex-col justify-center w-full min-h-screen py-12 bg-white dark:bg-slate-950 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <p className="text-center text-orange-600 dark:text-orange-400">Reset Password</p>
        <h2 className="text-3xl font-medium text-center text-gray-900 dark:text-white">
          Forgot your password?
        </h2>
        {message && <p className="mt-4 text-green-600 dark:text-green-400">{message}</p>}
        {error && <p className="mt-4 text-red-500 dark:text-red-400">{error}</p>}
      </div>
      <div className="flex justify-center mx-auto mt-8">
        <ForgotPasswordGraphic width={320} height={294} />
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="px-4">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 dark:text-slate-200"
              >
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full px-3 py-2 placeholder-gray-400 dark:placeholder-slate-400 border border-gray-300 dark:border-slate-600 rounded-md shadow-xs appearance-none bg-white dark:bg-slate-900 text-gray-900 dark:text-slate-100 focus:outline-hidden focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
              />
            </div>
            <div>
              <button
                type="submit"
                disabled={loading}
                className={`flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm ${
                  loading ? "bg-blue-400" : "hover:bg-blue-500"
                } focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600`}
              >
                Send Reset Link
              </button>
            </div>
            <p className="mt-2 text-sm text-center text-gray-600 dark:text-slate-300">
              {`We understand remembering passwords can be overwhelming. Don't worry
              we can work it out and help you setup a new password`}
            </p>
            <p className="mt-4 text-center text-sm text-gray-600 dark:text-slate-300">
              <Link
                href="/sign-in"
                className="font-semibold text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300"
              >
                Back to Login
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
